import { RootStore, IRootStoreParams } from './rootStore';
import { ServiceStore } from './serviceStore';
import { AuthStore, IAuthStoreOptions } from './authStore';
import type { IDefaultOfflineItemModel, IServiceStoreOptions } from './types';

export const createRootStore = (options: IRootStoreParams) => {
  return new RootStore(options);
};

export const createServiceStore = <ItemModel extends IDefaultOfflineItemModel, CreateItemModel>(
  rootStore: RootStore,
  options: IServiceStoreOptions,
) => {
  return new ServiceStore<ItemModel, CreateItemModel>(rootStore, options);
};

export const createAuthStore = (rootStore: RootStore, options: IAuthStoreOptions) => {
  return new AuthStore(rootStore, options);
};
